/**
 * @author Srijan Shakya
 * @description https://marvelapp.com/4g4b5dg/screen/60681743
 */

import React from 'react';
import { connect } from 'react-redux';
import filter from 'ramda/src/filter';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import DatePicker from '@components/@core/DatePicker';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import EditDropdown from '@components/EditDropdown';
import Filter from '@components/@core/Filter';
import ResponsiveTabs from '@components/@core/ResponsiveTabs';
import Tab from '@components/@core/Tab';
import AppActions from '~/actions/app';
import ManageActions from '~/actions/manage';
import { CompanyDevelopTabs, SPECIALOPTIONS, ReportMenu } from '~/services/config';
import { exportMultipleCsv } from '~/services/util-excel';
import Report from './Report';
import { TrainingCompetencyPdf } from './TrainingCompetencyPdf';

const moment = extendMoment(originalMoment);

class TrainingCompetency extends React.Component {
    state = {
        userId: this.props.userId,
        user: { id: this.props.userId },
        filter: 'employee',
        companyId: this.props.company.id,
        dateStart: moment().startOf('month').format('YYYY-MM-DD'),
        dateEnd: moment().endOf('month').format('YYYY-MM-DD'),
        activeTab: 'overall',
        processReport: [],
        skillsReport: [],
        productKnowledgeReport: [],
        tempermentReport: [],
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { trainingCompetencyReport } = nextProps;
        const { activeTab } = prevState;

        let processReport = [];
        let skillsReport = [];
        let productKnowledgeReport = [];
        let tempermentReport = [];

        if (!isNil(trainingCompetencyReport)) {
            processReport =
                isEmpty(trainingCompetencyReport.process) || isNil(trainingCompetencyReport.process)
                    ? []
                    : activeTab == 'overall'
                      ? trainingCompetencyReport.process.data
                      : filter((item) => item.category === activeTab, trainingCompetencyReport.process.data);
            skillsReport =
                isEmpty(trainingCompetencyReport.skills) || isNil(trainingCompetencyReport.skills)
                    ? []
                    : activeTab == 'overall'
                      ? trainingCompetencyReport.skills.data
                      : filter((item) => item.category === activeTab, trainingCompetencyReport.skills.data);
            productKnowledgeReport =
                isEmpty(trainingCompetencyReport.product_knowledge) || isNil(trainingCompetencyReport.product_knowledge)
                    ? []
                    : activeTab == 'overall'
                      ? trainingCompetencyReport.product_knowledge.data
                      : filter((item) => item.category === activeTab, trainingCompetencyReport.product_knowledge.data);
            tempermentReport =
                isEmpty(trainingCompetencyReport.temperament) || isNil(trainingCompetencyReport.temperament)
                    ? []
                    : activeTab == 'overall'
                      ? trainingCompetencyReport.temperament.data
                      : filter((item) => item.category === activeTab, trainingCompetencyReport.temperament.data);
            return { processReport, skillsReport, productKnowledgeReport, tempermentReport };
        } else return null;
    }

    componentDidMount() {
        const { dateStart, dateEnd, userId } = this.state;
        const payload = {
            user_id: userId,
            date_start: dateStart,
            date_end: dateEnd,
        };
        this.props.getReports(payload);
    }

    handleFilter = (type, data) => {
        const { dateStart, dateEnd, companyId } = this.state;
        if (data.length == 0) return;
        if (type === 'employee') {
            const userId = data[0].id;
            if (SPECIALOPTIONS.ALL == data[0].id) {
                const payload = {
                    company_id: [companyId],
                    date_start: dateStart,
                    date_end: dateEnd,
                };
                this.props.getReports(payload);
                this.setState({ filter: 'user' });
            } else {
                const payload = {
                    user_id: [userId],
                    date_start: dateStart,
                    date_end: dateEnd,
                };
                this.props.getReports(payload);
                this.setState({ user: data[0], userId, filter: 'user' });
            }
        }
        if (type == 'company') {
            const payload = {
                company_id: [data[0].id],
                date_start: dateStart,
                date_end: dateEnd,
            };
            this.props.getReports(payload);
            this.setState({ companyId: data[0].id, filter: 'company' });
        }
    };

    handleDate = (e) => {
        const { userId, companyId, filter } = this.state;
        const dateStart = moment(e.start).format('YYYY-MM-DD');
        const dateEnd = moment(e.end).format('YYYY-MM-DD');
        let payload = {};
        if (filter === 'employee') {
            payload = { user_id: [userId], date_start: dateStart, date_end: dateEnd };
        } else {
            payload = { company_id: [companyId], date_start: dateStart, date_end: dateEnd };
        }
        this.props.getReports(payload);
        this.setState({ dateStart, dateEnd });
    };

    handleExcelReport = () => {
        this.props.toggleModal({
            type: 'Confirm',
            data: {
                before: {
                    title: 'Confirm',
                    body: 'Would you like to download this reports data to excel?',
                },
            },
            callBack: {
                onYes: () => {
                    this.handleExcel();
                },
            },
        });
    };

    handleExcel = () => {
        const { activeTab, processReport, skillsReport, productKnowledgeReport, tempermentReport } = this.state;
        const processData = [];
        const skillsData = [];
        const productKnowledgeData = [];
        const tempermentData = [];
        processReport.map((item) => {
            const { data, children_complete, children_past_due } = item;
            const { child_count, name } = data;
            const excelData = {
                Training: name,
                Modules: child_count || 0,
                Completed: children_complete,
                'Past Due': children_past_due,
            };
            processData.push(excelData);
        });
        skillsReport.map((item) => {
            const { data, children_complete, children_past_due } = item;
            const { child_count, name } = data;
            const excelData = {
                Training: name,
                Modules: child_count || 0,
                Completed: children_complete,
                'Past Due': children_past_due,
            };
            skillsData.push(excelData);
        });
        productKnowledgeReport.map((item) => {
            const { data, children_complete, children_past_due } = item;
            const { child_count, name } = data;
            const excelData = {
                Training: name,
                Modules: child_count || 0,
                Completed: children_complete,
                'Past Due': children_past_due,
            };
            productKnowledgeData.push(excelData);
        });
        tempermentReport.map((item) => {
            const { data, children_complete, children_past_due } = item;
            const { child_count, name } = data;
            const excelData = {
                Training: name,
                Modules: child_count || 0,
                Completed: children_complete,
                'Past Due': children_past_due,
            };
            tempermentData.push(excelData);
        });
        const key = ['Training', 'Modules', 'Completed', 'Past Due'];
        const data = [processData, skillsData, productKnowledgeData, tempermentData];
        const sheetName = ['Process', 'Skills', 'Product Knowledge', 'Temperment '];
        exportMultipleCsv(data, key, sheetName, `Taining-Competency-${activeTab}`);
    };

    handleReportMenu = (e) => {
        switch (e) {
            case 'export':
                this.handleExcelReport();
                break;
            case 'print':
                const { dateStart, dateEnd, activeTab, processReport, skillsReport, productKnowledgeReport, tempermentReport } = this.state;
                const date = moment.range(dateStart, dateEnd);
                const pdfData = {
                    date: date,
                    activeTab: activeTab,
                    process: processReport,
                    skills: skillsReport,
                    productKnowledge: productKnowledgeReport,
                    temperment: tempermentReport,
                };
                TrainingCompetencyPdf(pdfData);
                break;
        }
    };

    render() {
        const { activeTab, dateStart, dateEnd, processReport, skillsReport, productKnowledgeReport, tempermentReport } = this.state;
        const date = moment.range(dateStart, dateEnd);

        return (
            <ErrorBoundary className="training-competency-report">
                <Filter onChange={this.handleFilter} />
                <div className="card">
                    <div className="d-flex ssm-column justify-content-between mb-2 mt-4 align-items-center">
                        <span className="dsl-b22 bold">Learning Competency Report</span>
                        <div className="d-flex mt-0 ssm-t-3">
                            <DatePicker calendar="range" format="MMM DD" as="span" align="right" append="caret" value={date} onSelect={this.handleDate} />
                            <EditDropdown className="ml-3" dataCy="editDropdown" options={ReportMenu} onChange={this.handleReportMenu} />
                        </div>
                    </div>
                    <ResponsiveTabs
                        className="ind-training-report justify-content-center"
                        data={CompanyDevelopTabs}
                        active={activeTab}
                        getId={(e) => e['name']}
                        getValue={(e) => e['label']}
                        onTab={(e) => this.setState({ activeTab: e.name })}
                    />
                    <Tab eventKey={activeTab} active={activeTab}>
                        <Report process={processReport} skills={skillsReport} productKnowledge={productKnowledgeReport} temperment={tempermentReport} />
                    </Tab>
                </div>
            </ErrorBoundary>
        );
    }
}

const mapStateToProps = (state) => ({
    userId: state.app.id,
    company: state.app.companies[0],
    trainingCompetencyReport: state.manage.trainingCompetencyReport,
});

const mapDispatchToProps = (dispatch) => ({
    getReports: (e) => dispatch(ManageActions.posttrainingcompetencyreportRequest(e)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingCompetency);
